var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M5 5h14v18H5z","key":0}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M1 20V1h15","key":1})]);
}

Copy.defaultProps = {"width":"20","height":"24","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
